<rx-button
  [compact]="true"
  [buttonClass]="params?.buttonClass"
  class="d-flex align-items-center justify-content-center h-100"
  [attr.data-qa]="params?.testIdPrefix ? params.testIdPrefix : 'grid-button'"
  (onClick)="onGridButtonClick()">
  <rx-icon [name]="params?.icon" />
</rx-button>